import type { AuthorPartyRole, DocumentCategory, RecipientRole } from "./types";

export const DOCUMENT_CATEGORY_VALUES: {
  value: DocumentCategory;
  required?: boolean;
}[] = [
  { value: "supplier_declaration", required: true },
  { value: "commercial_invoice", required: true },
  { value: "geolocation", required: true },
  { value: "bill_of_lading_cmr" },
  { value: "certificate_of_origin" },
  { value: "sustainability_certificate" },
  { value: "company_registration" },
  { value: "other" },
];

/** True when all DOCUMENT_CATEGORY_VALUES with required:true are present. */
export function documentsMinReady(documents: { category: DocumentCategory }[]): boolean {
  const present = new Set(documents.map((d) => d.category));
  return DOCUMENT_CATEGORY_VALUES.filter((c) => c.required).every((c) => present.has(c.value));
}

export const AUTHOR_PARTY_ROLE_VALUES: AuthorPartyRole[] = [
  "importer_operator",
  "trader_exporter",
  "processor_buyer",
  "supplier_producer",
  "compliance_broker",
];

export const RECIPIENT_ROLE_VALUES: RecipientRole[] = [
  "eu_buyer",
  "importer",
  "customs_broker",
  "internal_compliance",
  "regulator",
];

export const CASE_STATUS_KEYS = [
  "draft",
  "collecting_documents",
  "validated",
  "issues_found",
  "resolving",
  "passport_ready",
  "shared",
] as const;

/** Field keys per category for i18n lookup under compliance.extraction.fields.* */
export const EXTRACTION_FIELD_KEYS: Record<DocumentCategory, string[]> = {
  commercial_invoice: [
    "seller_name",
    "buyer_name",
    "product",
    "volume",
    "price",
    "incoterms",
    "invoice_number",
    "invoice_date",
  ],
  bill_of_lading_cmr: ["carrier", "route", "port", "shipment_date", "container_truck_ids"],
  certificate_of_origin: ["origin_country", "exporter", "producer", "product_category"],
  supplier_declaration: ["farm_id", "coordinates", "plot", "crop_type", "harvest_season"],
  geolocation: [
    "polygon_boundaries",
    "area",
    "coordinates",
    "geometry_valid",
    "crs",
    "crs_assumed",
    "area_ha",
    "polygon_count",
    "geometry_type",
    "geometry_issues",
    "preview_rings",
    "source_format",
  ],
  company_registration: ["vat", "legal_entity", "address", "ownership"],
  sustainability_certificate: ["scheme", "validity", "certifying_body", "expiration_date"],
  other: [],
};
